import React, { useEffect, useState } from "react";
import { GoEye, GoEyeClosed } from "react-icons/go";
import logo from "../assets/logo.png";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import { handleLogOut } from "../utils/user";
import { useLoginUserMutation } from "../redux/slices/authUser";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [passVisible, setPassVisible] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [login, { isLoading: authenticating }] = useLoginUserMutation();

  // Get the redirect path from location.state or default to /private
  const from = (location.state as any)?.from?.pathname || "/admin-panel";

  useEffect(() => {
    const user = localStorage.getItem("e-user");
    if (user) {
      navigate(from, { replace: true });  // Redirect if already logged in
    } else {
      handleLogOut();
    }
  }, [navigate, from]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("All Fields are required");
      return;
    }

    try {
      const res = await login({ email, password }).unwrap();

      if (res.token) {
        localStorage.setItem("e-user", JSON.stringify(res));
        setEmail("");
        setPassword("");
        navigate(from, { replace: true });  // Redirect to intended private page
      } else {
        console.log("ee", res);
        toast.error("Invalid login response");
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Unable to login");
    }
  };

  return (
    <div className="w-full min-h-screen px-3 bg-graylight flex items-start bg-slate-50">
      <div className="lg:w-[30%] md:w-[60%] sm:w-[80%] mx-auto bg-white shadow-md px-3 py-10 mt-6 rounded">
        <div className="h-[100px] w-[300px] mx-auto">
          <img src={logo} alt="Logo" className="w-full h-full object-contain" />
        </div>
        <p className="text-2xl text-center font-bold mt-2">Sign In</p>
        <p className="text-center">Welcome Back!</p>

        <form className="mt-5" onSubmit={handleLogin}>
          <div className="mb-2  px-3">
            <label
              htmlFor="email"
              className="mb-1 block text-black dark:text-white text-sm"
            >
              Email
            </label>
            <input
              type="text"
              id="email"
              name="email"
              placeholder="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-gray w-full text-black rounded border-[1.5px] border-stroke bg-transparent py-1 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
            />
          </div>
          <div className="mb-2  px-3">
            <label
              htmlFor="password"
              className="mb-1 block text-black dark:text-white text-sm"
            >
              Password
            </label>
            <span className="flex gap-2">
              <input
                id="password"
                type={passVisible ? "text" : "password"}
                name="password"
                placeholder="*****"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="border-gray w-full text-black rounded border-[1.5px] border-stroke bg-transparent py-1 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
              />

              <div
                className="w-10 py-1 border-[1.5px] rounded border-gray cursor-pointer flex justify-center items-center"
                onClick={() => setPassVisible(!passVisible)}
              >
                {passVisible ? <GoEyeClosed /> : <GoEye />}
              </div>
            </span>
          </div>
          <div className="w-full px-3 ">
            {authenticating ? (
              <button
                type="button"
                className="block w-full rounded border border-dark bg-dark py-1 text-center font-medium text-white transition hover:bg-opacity-75"
                disabled
              >
                Authenticating...
              </button>
            ) : (
              <button
                type="submit"
                className="block w-full rounded border border-orange bg-orange py-1 text-center font-medium text-white transition hover:bg-opacity-75"
              >
                Sign In
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
